import { ref } from 'vue';

export function useViewOptions() {
  const currentView = ref('main');

  const viewOptions = [
    { icon: 'crosshair_dot', value: 'main' },
    { icon: 'list_bullet_end', value: 'list' },
  ];

  return { currentView, viewOptions };
}
